(function () {
  if (window.__miniCartSetUpsellBound) return;
  window.__miniCartSetUpsellBound = true;

  const selectors = {
    block: '[data-mini-cart-set-upsell]',
    line: '#main-cart-items [data-line-index][data-variant-id]',
    config: '[data-mini-cart-product-set-config]',
    button: '.mini-cart-set-upsell__button',
    componentRemoveButton: '.mini-cart-set-component-remove__button'
  };
  const sectionIds = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];

  function getRoute(name, fallback) {
    return window.theme && theme.routes && theme.routes[name] ? theme.routes[name] : fallback;
  }

  function isProductSetsConfig(config) {
    return Boolean(config && config.parent_product && Array.isArray(config.sets));
  }

  function getPageProductSetsConfig() {
    const config = window.ProductSetsConfig;
    return isProductSetsConfig(config) ? config : null;
  }

  function parseConfigScript(script) {
    if (!script) return null;

    try {
      const config = JSON.parse(script.textContent || '{}');
      if (!isProductSetsConfig(config)) return null;

      config.lineIndex = script.dataset.lineIndex || '';
      config.lineKey = script.dataset.lineKey || '';
      config.parentVariantId = script.dataset.parentVariantId || (config.parent_product && config.parent_product.id);

      return config;
    }
    catch (error) {
      console.warn('Could not parse mini-cart product set data', error);
      return null;
    }
  }

  function getCartProductSetsConfigs() {
    return Array.from(document.querySelectorAll(selectors.config)).map(parseConfigScript).filter(Boolean);
  }

  function getProductSetsConfigs() {
    const configs = getCartProductSetsConfigs();
    const pageConfig = getPageProductSetsConfig();

    if (!pageConfig) return configs;

    configs.forEach((config) => {
      const sameParent = String(config.parent_product && config.parent_product.id) === String(pageConfig.parent_product.id);
      if (sameParent && pageConfig.labels) {
        config.labels = {
          ...pageConfig.labels,
          ...(config.labels || {})
        };
      }
    });

    const pageLine = getSetLine(pageConfig);
    const pageLineHasCartConfig = Boolean(
      pageLine &&
      configs.some((config) => {
        return getSetLine(config) === pageLine;
      })
    );

    return pageLineHasCartConfig ? configs : configs.concat(pageConfig);
  }

  function getFallbackProductSetsConfig() {
    return getProductSetsConfigs()[0] || getPageProductSetsConfig();
  }

  function getMiniCart() {
    return document.getElementById('mini-cart');
  }

  function getSetLine(config) {
    const lines = Array.from(document.querySelectorAll(selectors.line));
    if (config.lineKey) {
      const line = lines.find((element) => element.dataset.lineKey === String(config.lineKey));
      if (line) return line;
    }

    if (config.lineIndex) {
      const line = lines.find((element) => element.dataset.lineIndex === String(config.lineIndex));
      if (line) return line;
    }

    const parentVariantId = String(config.parentVariantId || (config.parent_product && config.parent_product.id) || '');
    if (!parentVariantId) return null;

    return lines.find((line) => {
      return line.dataset.variantId === parentVariantId || line.dataset.productSetParentId === parentVariantId;
    });
  }

  function getConfigForLine(line) {
    if (!line) return null;

    return getProductSetsConfigs().find((config) => {
      return getSetLine(config) === line;
    }) || null;
  }

  function getConfigForButton(button) {
    const line = button && button.closest(selectors.line);
    if (line) return getConfigForLine(line);

    const lineKey = button && button.dataset.lineKey;
    const lineIndex = button && button.dataset.line;
    const parentVariantId = button && button.dataset.parentVariantId;

    return getProductSetsConfigs().find((config) => {
      if (lineKey && String(config.lineKey) === String(lineKey)) return true;
      if (lineIndex && String(config.lineIndex) === String(lineIndex)) return true;
      return parentVariantId && String(config.parent_product && config.parent_product.id) === String(parentVariantId);
    }) || null;
  }

  function getProductSetLines() {
    return Array.from(document.querySelectorAll(selectors.line)).filter((line) => {
      return line.dataset.productSetParentId || line.dataset.productSetVariantData;
    });
  }

  function getLineTitle(line) {
    const title = line && line.querySelector('.product-title .link, .product-title');
    return title ? title.textContent.trim() : '';
  }

  function getHeading(block, line) {
    const baseHeading = block && block.dataset.heading ? block.dataset.heading.trim() : '';
    const title = getLineTitle(line);

    if (!baseHeading) return '';

    return getProductSetLines().length > 1 && title ? `${baseHeading}: ${title}` : baseHeading;
  }

  function parseVariantData(raw) {
    if (!raw) return [];

    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    }
    catch (error) {
      console.warn('Could not parse product set variant data', raw, error);
      return [];
    }
  }

  function getCurrentVariantData(line) {
    return parseVariantData(line ? line.dataset.productSetVariantData : '');
  }

  function isAvailable(item) {
    return Boolean(item && item.product && item.product.available && !item.product.quantity_rule_soldout);
  }

  function getSetItems(set) {
    const items = Array.isArray(set.items) ? set.items : [];
    return set.hide_sold_out ? items.filter(isAvailable) : items;
  }

  function isOptionalSet(set) {
  const minimumSelect = Number(set.minimum_select || 0);
  return Boolean(set && !set.hidden && minimumSelect < 1 && getSetItems(set).length);
}

function isSpecialOffersSet(set) {
  const description = String((set && set.description) || '').toLowerCase();
  return (
    description.includes('special') ||
    description.includes('extra')
  );
}

function getVariantId(item) {
  return Number(item && item.product && item.product.variant_id);
}

  function getDisplayItem(set, currentVariantData) {
    const selectedIds = new Set(currentVariantData.map((item) => Number(item && item.variantId)).filter(Boolean));
    const selectedItem = getSetItems(set).find((item) => selectedIds.has(getVariantId(item)));

    return selectedItem || getSetItems(set).find(isAvailable) || null;
  }

  function getLabel(config, name, fallback) {
    return config && config.labels && config.labels[name] ? config.labels[name] : fallback;
  }

  function getRows(config, currentVariantData) {
  const selectedIds = new Set(
    currentVariantData
      .map((row) => Number(row && row.variantId))
      .filter(Boolean)
  );

  return config.sets
    .filter(isOptionalSet)
    .flatMap((set) => {
      const items = isSpecialOffersSet(set)
        ? getSetItems(set)
        : [getDisplayItem(set, currentVariantData)];

      return items
        .filter(Boolean)
        .map((item) => {
          const variantId = getVariantId(item);

          return {
            set,
            item,
            variantId,
            alreadyAdded: selectedIds.has(variantId)
          };
        });
    })
    .filter((row) => !row.alreadyAdded && isAvailable(row.item));
}

  function getOptionalVariantIds(config) {
    const ids = new Set();
    if (!config) return ids;

    config.sets.filter(isOptionalSet).forEach((set) => {
      getSetItems(set).forEach((item) => {
        const variantId = getVariantId(item);
        if (variantId) ids.add(variantId);
      });
    });

    return ids;
  }

  function isOptionalVariant(config, variantId) {
    return getOptionalVariantIds(config).has(Number(variantId));
  }

  function escapeHtml(value) {
    const element = document.createElement('span');
    element.textContent = value == null ? '' : String(value);
    return element.innerHTML;
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/"/g, '&quot;');
  }

  function getImageUrl(url) {
    return url ? String(url) : '';
  }

  function getImageSrcset(item) {
    const image = item && item.product && item.product.image;
    const urls = image && image.urls && image.urls.x;

    if (urls && urls['1x'] && urls['2x']) {
      return `${getImageUrl(urls['1x'])} 1x, ${getImageUrl(urls['2x'])} 2x`;
    }

    return getImageUrl(image && image.url);
  }

  function getDisplayPrice(item, config) {
    return getTaxAdjustedPrice(item.price ?? (item.product && item.product.price), config);
  }

  function getCompareAtPrice(item, config) {
    const compareAtPrice = getTaxAdjustedPrice(item.compare_at_price ?? (item.product && item.product.compare_at_price), config);
    const displayPrice = getDisplayPrice(item, config);

    return compareAtPrice > displayPrice ? compareAtPrice : null;
  }

  function getTaxAdjustedPrice(price, config) {
    const tax = config.tax || {};
    const basePrice = Number(price || 0);
    const rate = Number(tax.rate || 1);
    const shouldAdjustForTax =
      (tax.price_includes_tax && !tax.fixed_price) ||
      (!tax.price_includes_tax && tax.country_code !== tax.shop_country_code);

    return shouldAdjustForTax ? basePrice * rate : basePrice;
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, theme.shopSettings && theme.shopSettings.moneyFormat);
    }

    return `£${(Number(cents || 0) / 100).toFixed(2)}`;
  }

  function renderImage(item) {
    const image = item.product && item.product.image;
    const src = getImageUrl(image && image.url);
    const srcset = getImageSrcset(item);

    if (!src) return '';

    return `
      <div class="product-image">
        <div class="media-wrapper media-wrapper--small">
          <div class="media media--adapt" style="--image-ratio-percent: 100%;">
            <img
              srcset="${escapeAttr(srcset)}"
              src="${escapeAttr(src)}"
              alt="${escapeAttr(item.product.title || item.name || '')}"
              width="92"
              height="92"
              loading="lazy"
              is="lazy-image"
            />
          </div>
        </div>
      </div>
    `;
  }

  function renderPrices(item, config) {
    const displayPrice = getDisplayPrice(item, config);
    const compareAtPrice = getCompareAtPrice(item, config);

    if (compareAtPrice) {
      return `
        <s class="price price-item--regular"><price-money><bdi>${escapeHtml(formatMoney(compareAtPrice))}</bdi></price-money></s>
        <span class="price price--sale"><price-money><bdi>${escapeHtml(formatMoney(displayPrice))}</bdi></price-money></span>
      `;
    }

    return `<span class="price"><price-money><bdi>${escapeHtml(formatMoney(displayPrice))}</bdi></price-money></span>`;
  }

  function renderRow(row, line, config) {
    const { set, item, variantId, alreadyAdded } = row;
    const title = item.name || (item.product && item.product.title) || '';
    const subtitle = item.product && item.product.subtitle;
    const addLabel = getLabel(config, 'add_this_option', 'Add this option');
    const addedLabel = getLabel(config, 'included', 'Added');
    const label = alreadyAdded ? addedLabel : addLabel;
    const buttonLabel = title ? (alreadyAdded ? `${title} ${addedLabel}` : `${addLabel}: ${title}`) : label;
    const mobileIcon = alreadyAdded ? '&#10003;' : '+';
    const disabled = alreadyAdded || !isAvailable(item);

    return `
      <li>
        <div class="product-container product-container--link${item.product && item.product.image ? '' : ' no-image'}">
          ${renderImage(item)}
          <div class="product-description">
            <div class="product-content">
              <p class="product-title">${escapeHtml(title)}</p>
              ${subtitle ? `<p class="color">${escapeHtml(subtitle)}</p>` : ''}
            </div>
            <div class="mini-cart__rec-prices">
              ${renderPrices(item, config)}
            </div>
          </div>
          <div class="product-button">
            <button
              type="button"
              class="mini-cart__add-btn mini-cart-set-upsell__button"
              data-line="${escapeAttr(line.dataset.lineIndex)}"
              data-line-key="${escapeAttr(line.dataset.lineKey || '')}"
              data-set-id="${escapeAttr(set.id)}"
              data-parent-variant-id="${escapeAttr(config.parent_product.id)}"
              data-child-variant-id="${escapeAttr(variantId)}"
              data-slot-label="${escapeAttr(set.description || '')}"
              aria-label="${escapeAttr(buttonLabel)}"
              ${disabled ? 'disabled="disabled"' : ''}
            >
              <span class="mini-cart__add-btn-text">
                <span class="mini-cart__add-btn-plus">+</span>
                <span class="label">${escapeHtml(label)}</span>
              </span>
              <span class="mini-cart__add-btn-icon" aria-hidden="true">${mobileIcon}</span>
            </button>
          </div>
        </div>
      </li>
    `;
  }

  function hideBlock(block) {
    if (!block) return;
    block.classList.add('hidden');
    block.innerHTML = '';
  }

  function renderUpsell() {
    const block = document.querySelector(selectors.block);
    if (!block) return;

    const groups = getProductSetsConfigs()
      .map((config) => {
        const line = getSetLine(config);
        if (!line) return null;

        const currentVariantData = getCurrentVariantData(line);
        const rows = getRows(config, currentVariantData);
        return rows.length ? { config, line, rows } : null;
      })
      .filter(Boolean);

    if (!groups.length) return hideBlock(block);

    block.innerHTML = groups.map(({ config, line, rows }) => {
      return `
        <div class="mini-cart-set-upsell__group">
          <div class="cart-recommendations__title h4">${escapeHtml(getHeading(block, line))}</div>
          <ul class="mini-cart__navigation">
            ${rows.map((row) => renderRow(row, line, config)).join('')}
          </ul>
        </div>
      `;
    }).join('');
    block.classList.remove('hidden');
  }

  function syncComponentRemoveButtons() {
    document.querySelectorAll(selectors.componentRemoveButton).forEach((button) => {
      const line = button.closest(selectors.line);
      const config = getConfigForLine(line);
      const optionalVariantIds = getOptionalVariantIds(config);
      const removeVariantId = Number(button.dataset.removeVariantId);
      const requiredVariantIds = new Set();

if (config) {
  config.sets
    .filter((set) => Number(set.minimum_select || 0) >= 1)
    .forEach((set) => {
      getSetItems(set).forEach((item) => {
        const variantId = getVariantId(item);
        if (variantId) requiredVariantIds.add(variantId);
      });
    });
}

const canRemove = Boolean(
  config &&
  optionalVariantIds.has(removeVariantId) &&
  !requiredVariantIds.has(removeVariantId)
);


      button.hidden = !canRemove;
      if (canRemove) {
        button.removeAttribute('disabled');
      }
      else {
        button.setAttribute('disabled', 'disabled');
      }
    });
  }

  function renderSetControls() {
    renderUpsell();
    syncComponentRemoveButtons();
  }

  function buildAics(item) {
    const price = Number(item.price ?? (item.product && item.product.price) ?? 0);
    return `0G${price * 83}`;
  }

  function buildMarketAics(item) {
    if (!Array.isArray(item.prices)) return null;

    return item.prices.map((price) => ({
      mk: price.market,
      aics: `0G${Number(price.price || 0) * 83}`
    }));
  }

  function getQuantityMultiplier(item) {
    const multiplier = Number(item.quantity_multiplier || 0);
    return multiplier > 0 ? multiplier : 1;
  }

  function buildVariantDataItem(item) {
    const data = {
      variantId: getVariantId(item),
      quantity: getQuantityMultiplier(item),
      aics: buildAics(item)
    };
    const mkAics = buildMarketAics(item);

    if (mkAics) data.mk_aics = mkAics;

    return data;
  }

  function findConfigItem(config, setId, variantId) {
    const set = config.sets.find((entry) => String(entry.id) === String(setId));
    if (!set) return null;

    const item = getSetItems(set).find((entry) => getVariantId(entry) === Number(variantId));
    return item ? { set, item } : null;
  }

  async function getCart() {
    const cartUrl = `${getRoute('cart_url', '/cart')}.js`;
    const response = await fetch(cartUrl, { headers: { Accept: 'application/json' } });
    const cart = await response.json();

    if (!response.ok || cart.status) {
      throw new Error(cart.description || cart.message || 'Could not read the cart.');
    }

    return cart;
  }

  function getLineItem(cart, lineNumber) {
    return cart && Array.isArray(cart.items) ? cart.items[Number(lineNumber) - 1] : null;
  }

  function getSectionsToRender() {
    const miniCart = getMiniCart();
    if (miniCart && typeof miniCart.getSectionsToRender === 'function') {
      return miniCart.getSectionsToRender().map((section) => section.id);
    }

    return sectionIds;
  }

  function wasDrawerOpen() {
    const details = document.querySelector('cart-drawer details');
    return Boolean(details && details.hasAttribute('open'));
  }

  function getOpenDetailsLine() {
    const openDetails = document.querySelector('mini-cart-item-details details[open]');
    const line = openDetails && openDetails.closest('[data-line-index]');
    return line ? line.dataset.lineIndex : null;
  }

  function restoreDetails(lineIndex) {
    if (!lineIndex) return;

    const line = Array.from(document.querySelectorAll(selectors.line)).find((element) => {
      return element.dataset.lineIndex === String(lineIndex);
    });
    const details = line && line.querySelector('mini-cart-item-details details');
    const toggle = line && line.querySelector('mini-cart-item-details-toggle');
    const icon = toggle && toggle.querySelector('.mini-cart__accordion-icon');

    if (details) details.open = true;
    if (toggle) toggle.classList.add('open');
    if (icon) icon.textContent = '\u2212';
  }

  function renderSections(parsedState, shouldReopenDrawer, openDetailsLine) {
    const miniCart = getMiniCart();

    if (miniCart && typeof miniCart.renderContents === 'function') {
      miniCart.renderContents(parsedState);
    }
    else if (parsedState && parsedState.sections) {
      sectionIds.forEach((id) => {
        const element = document.getElementById(id);
        const html = parsedState.sections[id];
        if (!element || !html) return;

        const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
        const section = parsedHtml.querySelector('.shopify-section');
        if (section) element.innerHTML = section.innerHTML;
      });

      if (shouldReopenDrawer) {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.openMenuDrawer === 'function') drawer.openMenuDrawer();
      }
    }

    window.requestAnimationFrame(() => {
      restoreDetails(openDetailsLine);
      renderSetControls();
    });
  }

  async function updateSetLine(button) {
    const config = getConfigForButton(button);
    if (!config) throw new Error('Product set data is not available on this page.');

    const lineNumber = Number(button.dataset.line);
    const configItem = findConfigItem(config, button.dataset.setId, button.dataset.childVariantId);
    if (!lineNumber || !configItem) throw new Error('Could not find the selected set item.');

    const cart = await getCart();
    const lineItem = getLineItem(cart, lineNumber);
    if (!lineItem) throw new Error('Could not find the set line in the cart.');

    const currentVariantData = parseVariantData(lineItem.properties && lineItem.properties._productSetVariantData);
    const selectedVariantId = getVariantId(configItem.item);
    const itemAlreadyAdded = currentVariantData.some(
  (item) => Number(item && item.variantId) === selectedVariantId
);

if (itemAlreadyAdded) return null;

const setVariantIds = new Set(getSetItems(configItem.set).map(getVariantId));

const slotAlreadyFilled =
  !isSpecialOffersSet(configItem.set) &&
  currentVariantData.some((item) =>
    setVariantIds.has(Number(item && item.variantId))
  );

if (slotAlreadyFilled) return null;

    const updatedVariantData = currentVariantData.concat(buildVariantDataItem(configItem.item));
    const properties = {
      ...(lineItem.properties || {}),
      _productSetParentId: Number(config.parent_product.id),
      _productSetVariantData: JSON.stringify(updatedVariantData)
    };

    const body = JSON.stringify({
      line: lineNumber,
      quantity: lineItem.quantity,
      properties,
      sections: getSectionsToRender(),
      sections_url: window.location.pathname
    });

    const response = await fetch(getRoute('cart_change_url', '/cart/change.js'), {
      ...(typeof fetchConfig === 'function' ? fetchConfig() : {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
      }),
      body
    });
    const parsedState = await response.json();

    if (!response.ok || parsedState.status || parsedState.errors) {
      throw new Error(parsedState.description || parsedState.message || parsedState.errors || 'Could not update your set.');
    }

    return parsedState;
  }

  async function removeSetComponent(button) {
    const line = button.closest(selectors.line);
    const config = getConfigForLine(line);
    if (!config) throw new Error('Product set data is not available on this page.');

    const lineNumber = Number(button.dataset.line || (line && line.dataset.lineIndex));
    const removeVariantId = Number(button.dataset.removeVariantId);
    if (!lineNumber || !removeVariantId) throw new Error('Could not find the selected set item.');
    if (!isOptionalVariant(config, removeVariantId)) throw new Error('This set item cannot be removed from the mini-cart.');

    const cart = await getCart();
    const lineItem = getLineItem(cart, lineNumber);
    if (!lineItem) throw new Error('Could not find the set line in the cart.');

    const currentVariantData = parseVariantData(lineItem.properties && lineItem.properties._productSetVariantData);
    const updatedVariantData = currentVariantData.filter((item) => Number(item && item.variantId) !== removeVariantId);
    if (updatedVariantData.length === currentVariantData.length) return null;

    const properties = {
      ...(lineItem.properties || {}),
      _productSetParentId: Number((lineItem.properties && lineItem.properties._productSetParentId) || config.parent_product.id),
      _productSetVariantData: JSON.stringify(updatedVariantData)
    };

    const body = JSON.stringify({
      line: lineNumber,
      quantity: lineItem.quantity,
      properties,
      sections: getSectionsToRender(),
      sections_url: window.location.pathname
    });

    const response = await fetch(getRoute('cart_change_url', '/cart/change.js'), {
      ...(typeof fetchConfig === 'function' ? fetchConfig() : {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
      }),
      body
    });
    const parsedState = await response.json();

    if (!response.ok || parsedState.status || parsedState.errors) {
      throw new Error(parsedState.description || parsedState.message || parsedState.errors || 'Could not remove this item from your set.');
    }

    return parsedState;
  }

  function setButtonLoading(button, isLoading) {
    const label = button.querySelector('.label');
    const config = getConfigForButton(button) || getFallbackProductSetsConfig();
    const loadingLabel = getLabel(config, 'loading', 'Loading...');
    const addLabel = getLabel(config, 'add_this_option', 'Add this option');

    if (isLoading) {
      button.dataset.originalLabel = label ? label.textContent : '';
      button.classList.add('is-loading');
      button.setAttribute('disabled', 'disabled');
      if (label) label.textContent = loadingLabel;
      button.setAttribute('aria-busy', 'true');
      return;
    }

    button.classList.remove('is-loading');
    button.removeAttribute('disabled');
    button.removeAttribute('aria-busy');
    if (label) label.textContent = button.dataset.originalLabel || addLabel;
    delete button.dataset.originalLabel;
  }

  function setButtonAdded(button) {
    const label = button.querySelector('.label');
    const icon = button.querySelector('.mini-cart__add-btn-icon');
    const config = getConfigForButton(button) || getFallbackProductSetsConfig();
    button.classList.remove('is-loading');
    button.setAttribute('disabled', 'disabled');
    button.removeAttribute('aria-busy');
    if (label) label.textContent = getLabel(config, 'included', 'Added');
    if (icon) icon.innerHTML = '&#10003;';
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest(selectors.button);
    if (!button) return;

    event.preventDefault();
    if (button.classList.contains('is-loading')) return;

    const shouldReopenDrawer = wasDrawerOpen();
    const openDetailsLine = getOpenDetailsLine();
    setButtonLoading(button, true);

    try {
      const parsedState = await updateSetLine(button);
      if (!parsedState) {
        setButtonAdded(button);
        return;
      }

      renderSections(parsedState, shouldReopenDrawer, openDetailsLine);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: parsedState } }));
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: parsedState } }));
    }
    catch (error) {
      console.error('Mini-cart set upsell error:', error);
      alert(error.message || 'An error occurred while updating your set.');
      setButtonLoading(button, false);
    }
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest(selectors.componentRemoveButton);
    if (!button) return;

    event.preventDefault();
    if (button.classList.contains('is-loading')) return;

    const shouldReopenDrawer = wasDrawerOpen();
    const openDetailsLine = getOpenDetailsLine();
    button.classList.add('is-loading');
    button.setAttribute('disabled', 'disabled');
    button.setAttribute('aria-busy', 'true');

    try {
      const parsedState = await removeSetComponent(button);
      if (!parsedState) {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
        syncComponentRemoveButtons();
        return;
      }

      renderSections(parsedState, shouldReopenDrawer, openDetailsLine);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: parsedState } }));
    }
    catch (error) {
      console.error('Mini-cart set component remove error:', error);
      alert(error.message || 'An error occurred while removing this item from your set.');
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
      syncComponentRemoveButtons();
    }
  });

  ['DOMContentLoaded', 'cartdrawer:opened', 'cart:updated', 'ajaxProduct:added', 'page:loaded'].forEach((eventName) => {
    document.addEventListener(eventName, renderSetControls);
  });

  const miniCart = getMiniCart();
  if (miniCart) {
    new MutationObserver(() => {
      window.requestAnimationFrame(renderSetControls);
    }).observe(miniCart, { childList: true });
  }

  renderSetControls();
})();
